import { makeAutoObservable } from 'mobx';
import {
  DELETE_UPLOAD,
  GET_OUTPUT_DOWNLOAD_URL,
  GET_UPLOADS_BY_DATE_RANGE,
  GET_UPLOAD_EXHIBIT_URLS,
  GET_UPLOAD_URLS,
  PROCESS_UPLOAD,
  VALIDATE_UPLOAD,
} from 'api/queries/carrierFileService';
import { Upload, UploadFile, UploadUrls } from 'types/carrierFileService';
import apolloClient from 'api/apolloClient';
import { FetchResult } from '@apollo/client';

export class CarrierFileStore {
  // eslint-disable-next-line class-methods-use-this
  async getUploadsByDateRange(from: string, to: string, sponsorId: string): Promise<Upload[]> {
    const result = await apolloClient.query<{ getUploadsByDateRange: Upload[] }>({
      query: GET_UPLOADS_BY_DATE_RANGE,
      fetchPolicy: 'no-cache',
      variables: { from, to, sponsorId },
    });
    return result.data.getUploadsByDateRange;
  }

  // eslint-disable-next-line class-methods-use-this
  async getUploadUrls(files: UploadFile[], sponsorId: string): Promise<UploadUrls> {
    const response = await apolloClient.query<{ getUploadUrls: UploadUrls }>({
      query: GET_UPLOAD_URLS,
      fetchPolicy: 'no-cache',
      variables: { files, sponsorId },
    });

    return response.data.getUploadUrls;
  }

  // eslint-disable-next-line class-methods-use-this
  async getUploadExhibitUrls(files: string[], sponsorId: string, effectiveDate: string): Promise<UploadUrls> {
    const response = await apolloClient.query<{ getUploadExhibitUrls: UploadUrls }>({
      query: GET_UPLOAD_EXHIBIT_URLS,
      fetchPolicy: 'no-cache',
      variables: { files, sponsorId, effectiveDate },
    });

    return response.data.getUploadExhibitUrls;
  }

  // eslint-disable-next-line class-methods-use-this
  async getOutputDownloadUrl(uploadId: string, fileName: string): Promise<string> {
    const response = await apolloClient.query<{ getOutputDownloadUrl: string }>({
      query: GET_OUTPUT_DOWNLOAD_URL,
      fetchPolicy: 'no-cache',
      variables: { uploadId, fileName },
    });

    return response.data.getOutputDownloadUrl;
  }

  // eslint-disable-next-line class-methods-use-this
  async deleteUpload(uploadId: string): Promise<FetchResult<{ deleteUpload: Upload }>> {
    return apolloClient.mutate<{ deleteUpload: Upload }>({
      mutation: DELETE_UPLOAD,
      variables: { uploadId },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async validateUpload(uploadId: string): Promise<FetchResult<{ validateUpload: Upload }>> {
    return apolloClient.mutate<{ validateUpload: Upload }>({
      mutation: VALIDATE_UPLOAD,
      variables: { uploadId },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async processUpload(uploadId: string): Promise<FetchResult<{ processUpload: Upload }>> {
    return apolloClient.mutate<{ processUpload: Upload }>({
      mutation: PROCESS_UPLOAD,
      variables: { uploadId },
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
